import { TogglesController } from "../controller";

export default class extends TogglesController {
  static values = { active: { type: Boolean, default: false } };

  _activate() {
    this.activeIconTarget.classList.remove("hidden");
    this.inactiveIconTarget.classList.add("hidden");
  }

  _deactivate() {
    this.activeIconTarget.classList.add("hidden");
    this.inactiveIconTarget.classList.remove("hidden");
  }
}
